import { app } from '@/app';
import { removeFavoriteMaterial as removeFavorite } from '@/app/api/morgan-thermal/material/remove-favorite';
import { MaterialInformation } from '@/app/api/morgan-thermal/material';

export const removeFavoriteMaterial = (id: MaterialInformation['id']) => app.morganThermalAPI.fetch(removeFavorite(id));